import { ChangeDetectorRef, Component } from '@angular/core';
import { Notification } from '@portal/shared/ui/notifier/src';
import { NotificationType } from './notification-type.enum';
import { Notifier } from './notifier';
import { NotifierService } from './notifier.service';
import { ToastService } from '@portal/shared/ui/toast/src';
import { Router } from '@angular/router';

@Component({
    selector: 'portal-notifier',
    templateUrl: './notifier.component.html',
    styleUrls: ['./notifier.component.scss'],
    standalone: false
})
export class NotifierComponent {
  FAIL = NotificationType.Fail;
  SUCCESS = NotificationType.Success;
  INFO = NotificationType.Info;
  WARN = NotificationType.Warn;
  REPORT = NotificationType.SuccessWithReportId;
  TOAST = NotificationType.Toast;
  notifier: Notifier;

  constructor(
    private notifierService: NotifierService,
    private cdRef: ChangeDetectorRef,
    public toastService: ToastService,
    private router: Router,
  ) {
    this.notifier = notifierService.notifier;
  }

  destroy(notification: Notification): void {
    this.notifier.destroy(notification);
    this.cdRef.detectChanges();
  }

  copy(reportId: string): void {
    if (!reportId) {
      return null;
    }
    navigator.clipboard
      .writeText(reportId.toString())
      .then(() => {
        this.notifierService.toast($localize`Successfully copied ${reportId} to clipboard!`);
      })
      .catch(() => {});
  }

  copyId(notification: Notification): void {
    if (!notification.copyText) {
      return;
    }
    navigator.clipboard
      .writeText(notification.copyText)
      .then(() => {
        notification.copied = true;
        setTimeout(() => {
          notification.copied = false;
          this.cdRef.detectChanges();
        }, 2000);
        this.cdRef.detectChanges();
      })
      .catch(() => {});
  }

  goto(reportId: string): void {
    if (reportId) {
      const queryParams = { reportid: reportId, download: 'true' };
      this.router.navigate(['/reports/generated-reports'], { queryParams });
    }
  }
}
